/**
 * Pastille : un texte court sur la teinte de son ton (« À valider », « Faite »,
 * « Vous êtes ici »). Pour l'état d'un enregistrement connu de l'API, préférer
 * `StateBadge`, qui choisit le libellé et le ton à partir de l'état.
 */
import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'info' | 'ok' | 'warn' | 'danger';

export function Badge(props: {
  tone?: BadgeTone;
  children: ReactNode;
  title?: string;
  /** Texte long (« E-facture en cours de dépôt (simulation) ») : passe à la ligne au lieu de déborder à 320 px. */
  wrap?: boolean;
  /** Pictogramme qui dit le sujet (la facturation) à la place du point. */
  icon?: ReactNode;
  /** Plus petite, pour une case serrée (un bloc du planning, une ligne). */
  compact?: boolean;
}): ReactNode {
  const tone = props.tone ?? 'neutral';
  const classes = [
    'badge', tone !== 'neutral' && `badge--${tone}`, props.wrap && 'badge--wrap',
    props.icon !== undefined && 'badge--icon', props.compact && 'badge--compact',
  ].filter(Boolean).join(' ');
  return (
    <span className={classes} title={props.title}>
      {props.icon}
      {props.children}
    </span>
  );
}

/**
 * Plusieurs pastilles côte à côte, à la place d'une seule (l'état et la
 * facturation d'une intervention) : dans une `RecordRow`, le groupe prend la
 * place de la pastille.
 */
export function BadgeGroup(props: { children: ReactNode }): ReactNode {
  return <span className="badge-group">{props.children}</span>;
}
